<template>
  <div class="verifyEmail">
    <h1>Du må verifisere e-posten din.</h1>
    <p>
      Vennligst sjekk din e-post og trykk på "verify your account" der for å
      fortsette.
    </p>
    <button @click="Resend()">{{ text }}</button>
    <!-- Ha mailikon her som gjør det enklere å differensiere knappene -->
    <button @click="forceRefresh()">Fortsett</button>
  </div>
</template>

<script>
import axios from "axios";
import { getInstance } from "../auth/index";
import store from "../store/index.js";
export default {
  name: "VerifiserEpost",
  data() {
    return {
      text: "Send lenke på nytt",
      auth0Id: this.$auth.user.sub,
      reponse: null,
    };
  },
  mounted() {
    const authService = getInstance();
    if (authService.user.email_verified) {
      this.$router.push({ name: "Profile" });
    }
  },
  components: {},
  methods: {
    async Resend() {
      const authService = getInstance();
      const token = await this.$auth.getTokenSilently();
      let axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      };

      await axios
        .post(
          `${store.state.baseApiUrl}/Auth0/${this.$auth.user.sub}/resend-email`,
          axiosConfig
        )
        .then((response) => {
          this.response = response.data;
          authService.logout();
        })
        .catch((error) => {
          console.error("Email not sent due to: " + error);
        });
    },

    forceRefresh() {
      this.$router.go(0);
    },
  },
};
</script>